import { type MetricField, type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";
import { ejectTotalMetricValue } from "../filters";

export type TotalsMap = { [key in MetricField]?: number };

/**
 *
 * Similar to mapLifetimeTotalValues
 * But returns a totals map containing not formatted total values only
 * example: { SWIPE_UPS: 100, LENS_PLAYS: 2000 }
 *
 */
export const mapFieldsToLifetimeTotalValues = (
    fields: MetricField[],
    responseLifetimeValues: readonly MyLensesOrganicStatsResponseEntry[],
): TotalsMap => {
    const defaults: TotalsMap = Object.fromEntries(fields.map((field) => [field, 0]));

    if (responseLifetimeValues.length > 0) {
        return fields.reduce((acc, field) => {
            const totalValue = Number.parseInt(ejectTotalMetricValue(responseLifetimeValues, field));
            if (totalValue) {
                return {
                    ...acc,
                    [field]: totalValue,
                };
            }

            return acc;
        }, defaults);
    }

    return defaults;
};
